import { TEMP_ATTRIBUTES_CODES } from "@/vue/constants/attribute-types";

/**
 * @ngdoc Controller
 * @name AlarmsSettingsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('AddAlarmsSettingsController', AddAlarmsSettingsController);

    /**
     * @constructor
     * @ngInject
     */
    function AddAlarmsSettingsController($log, $scope, $state, $stateParams, ApiService, vrmNotificationsService, vrmNotificationType, locale, UserService) {
        $log.info('AddAlarmsSettingsController');

        $scope.step = 1;
        $scope.tempCodes = TEMP_ATTRIBUTES_CODES;
        $scope.model = {
            device: null,
            attribute: null,
            toggles: {}
        };

        $scope.forms = {};
        $scope.symbol = '°C';

        UserService.getUser().then(function(user) {
            $scope.symbol = user.useFahrenheit ? '°F' : '°C';
        });

        ApiService.installations($stateParams.id, 'alarms').then(function (response) {
            $scope.attributes = {};
            // create referenced list by data attribute code
            _.each(response.data.attributes, function(dataAttribute) {
                $scope.attributes[dataAttribute.idDataAttribute] = dataAttribute;
            });

            var arrAttributes = [];
            _.each(response.data.attributes, function(dataAttribute) {
                    if (dataAttribute.dataType === "enum" && !dataAttribute.enumValues)
                        return;
                    arrAttributes.push(dataAttribute);
            });
            $scope.attributeList = arrAttributes;
            $scope.devices = response.data.devices;

            $scope.next = function(form) {
                if (form != undefined && !form.$valid) {
                    form.$submitted = true;
                    return;
                } else if (form != undefined) {
                    form.$submitted = false;
                }

                //Deselect attribute when other type selected
                if ($scope.step == 1 && $scope.model.attribute && $scope.model.device.idDeviceType != $scope.model.attribute.idDeviceType) {
                    $scope.model.attribute = null;
                    $scope.model.toggles = {};
                }

                $scope.step++;
            };

            $scope.previous = function() {
                $scope.step--;
            };

            $scope.preventNonNumericalInput = function (event) {
                // Necessary to verify using this for the following reasons
                // 1) firefox allows chars in input type number
                // 2) Firefox's ParseFloat method crashes when you enter a comma but not in chrome
                // 3) Validators are not ran at all when entering a char which makes it 
                // impossible to throw a proper validation error

                const e = event || window.event;
                var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
                var charStr = String.fromCharCode(charCode);

                const inputFieldvalue = event.currentTarget.value;
                const charactersAllowedOnce = ['+', '-', '.'];

                if (!charStr.match(/^[+-.]|[0-9]/)) {
                    e.preventDefault();
                }
                else {
                    //cannot use regex further as we need to then predict the output
                    if (charactersAllowedOnce.includes(charStr) && inputFieldvalue.includes(charStr)) {
                        e.preventDefault();
                    }
                }
            };

            $scope.save = function(form) {
                if (form != undefined && !form.$valid) {
                    form.$submitted = true;
                    return;
                }
                var data = {
                    instance: $scope.model.device.instance,
                    idDataAttribute: $scope.model.attribute.idDataAttribute
                };
                if ($scope.model.attribute.dataType == 'float') {
                    _.extend(data, _.pick($scope.model, 'lowAlarm', 'lowAlarmHysteresis', 'highAlarm', 'highAlarmHysteresis'));
                    data['NotifyAfterSeconds'] = $scope.model.timeout;
                    data['AlarmEnabled'] = 1;
                } else if ($scope.model.attribute.dataType == 'enum') {
                    data['enumValues'] = [];

                    for (var n in $scope.model.attribute.enumValues)
                    {
                        var value = $scope.model.attribute.enumValues[n].valueEnum;
                        if (typeof $scope.model.toggles[$scope.model.attribute.enumValues[n].valueEnum] == "undefined")
                        {
                            $scope.model.toggles[value] = false;
                        }
                    }
                    _.each($scope.model.toggles, function(val, key) {
                        if (!val) {
                            data['enumValues'].push(parseInt(key));
                        }
                    });

                    data['notifyAfterSeconds'] = $scope.model.timeout;
                    data['alarmEnabled'] = 1;
                }

                ApiService.installations($stateParams.id, 'alarms', data, 'POST').then(function() {
                    $state.go('base.installation.settings.alarms');
                    vrmNotificationsService.add({
                        type: vrmNotificationType.SUCCESS,
                        message: locale.getString('alarms.alarm_added')
                    });
                });
            };
        });
    }

})();
